import { useNavigate } from 'react-router-dom';

import LoginPage from '../../../presentation/page/auth/LoginPage';

import { LoginUseCase } from '../../../data/useCase/LoginUseCase';

import { PrivateRoutes } from '../../../main/constant/RouteConstant';

import { setLocalStorege } from '../../../infra/cache/LocalstorageCache';

import { UseAlert } from '../../../presentation/hook/AlertHook';
import { HttpStatusCodeEnum } from '../../enums/HttpStatusCodeEnum';
import MessageConstant from '../../../main/constant/MessageConstant';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';
import { LocalStorageKeysConstant } from '../../../main/constant/LocalStorageKeysConstant';

/**
 * LoginPageDomain - regra de negocio de login
 * @constructor
 */
export const LoginPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * navegacao da url
   */
  let navigate = useNavigate();

  /**
   * endpoint
   */
  const ENDPOINT_LOGIN = EndpointsConstant.login;

  /**
   * chave do localstorage
   */
  const TOKEN_USER_LOGIN = LocalStorageKeysConstant.tokenUserLogin ?? 'intelidente-token-login';
  const CALENDARIO = LocalStorageKeysConstant.calendar ?? 'calendario';

  /**
   * authentication
   * @param params
   */
  const authentication = async (params: { login: string; password: string }) => {
    setLocalStorege(CALENDARIO, {
      visualizacao: 'timeGridWeek',
    });
    const loginFormData = new FormData();
    loginFormData.append('username', params.login);
    loginFormData.append('password', params.password);

    await new LoginUseCase(`${ENDPOINT_LOGIN}`)
      .Post({
        data: {
          login: params.login,
          password: params.password,
        },
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode === HttpStatusCodeEnum.ok) {
          navigate(PrivateRoutes.HOME);
          setLocalStorege(TOKEN_USER_LOGIN, response.body);
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }
      })
      .catch((error) => {
        if (error.response.status === HttpStatusCodeEnum.unauthorized) {
          showAlert({
            show: true,
            content: error.response?.data?.message,
            color: 'warning',
            time: 2000,
          });
        } else {
          showAlert({
            show: true,
            content: MessageConstant.erro.generico,
            color: 'danger',
            time: 2000,
          });
        }

        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <LoginPage authentication={authentication} />
    </>
  );
};
